import React from 'react'
import Divider from '@mui/material/Divider'
import PropTypes from 'prop-types'

/**
 *
 * @param {Object} props
 * @param {import('../../../../../../types/provision.type').ProvisioningStatus} props.provisionedItems
 * @param {boolean} props.hasValidState
 */
function ProvisionedItemsDetails(props) {
  const { provisionedItems } = props

  if (!props.hasValidState) {
    return <div>Items have not be provisioned for this order.</div>
  }

  return (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <td colSpan={4}>
            <Divider sx={{ mb: 1.5, width: '100%' }} />
          </td>
        </tr>
        <tr>
          <th style={{ textAlign: 'left' }}>ICCID</th>
          <th style={{ textAlign: 'left' }}>MSISDN</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={4}>
            <Divider style={{ width: '100%' }} sx={{ mt: 1.5 }} />
          </td>
        </tr>
        {provisionedItems.map((pair, index) => (
          <tr key={index}>
            <td style={{ paddingTop: '1em' }}>{pair.iccid}</td>
            <td style={{ paddingTop: '1em' }}>{pair.msisdn}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

ProvisionedItemsDetails.propTypes = {
  provisionedItems: PropTypes.array,
  hasValidState: PropTypes.bool
}

export default ProvisionedItemsDetails
